import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        cash: "border-transparent bg-blue-500/20 text-blue-600 dark:bg-blue-500/30 dark:text-blue-400",
        online: "border-transparent bg-purple-500/20 text-purple-600 dark:bg-purple-500/30 dark:text-purple-400",
        sale: "border-transparent bg-[hsl(var(--ledger-sale))] text-white hover:bg-[hsl(var(--ledger-sale))]/80",
        purchase: "border-transparent bg-[hsl(var(--ledger-purchase))] text-white hover:bg-[hsl(var(--ledger-purchase))]/80",
        opening: "border-transparent bg-[hsl(var(--ledger-opening))] text-white hover:bg-[hsl(var(--ledger-opening))]/80",
        payment: "border-transparent bg-[hsl(var(--ledger-payment))] text-white hover:bg-[hsl(var(--ledger-payment))]/80",
        return: "border-transparent bg-[hsl(var(--ledger-return))] text-white hover:bg-[hsl(var(--ledger-return))]/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
